<template>
  <div class="absolute text-align-center" style="top: 50%;left: 50%;transform: translate(-50%,-50%);">
    <div class="text-align-center color-white"
         style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
      <i class="r2-icon-action_description" style="font-size: 30px;"></i>
    </div>
    <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData'
}
</script>

<style scoped>

</style>
